export const bool = {
	selected: {
		option: '----',
		value: ''
	},
	options: ['হ্যাঁ', 'না'],
};